<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="list-wrap mg-b-15">
      <div class="hidden-btn"></div>
      <div class="hidden-btn2"></div>
      <!-- header -->
      <div class="list-heard d-flex mg-b-5">
        <div class="d-flex pd-x-5 flex-1">
          <div class="c-8 tx-white d-flex align-items-center">
            <label class="ckbox mg-0">
              <input
                type="checkbox"
                :checked="isAll"
                @change="changeAllCheck($event)"
              />
              <span></span>
            </label>
            {{ $t("product.商品信息") }}
            <a
              href="javascript:;"
              class="mg-l-5 sp-dd d-inline-block"
              :class="{
                'tx-info': sortType2 == 'name',
                'tx-gray-500': sortType2 != 'name',
                up: sorts2 == 'name ASC',
              }"
              @click="sortList('name')"
              data-toggle="tooltip"
              data-placement="right"
              :data-original-title="$t('product.按商品名称排序')"
              >▼</a
            >
            <a
              class="mg-l-10 tx-info tx-12"
              href="javascript:;"
              @click="accordionProducts"
            >
              {{ isAccordion ? $t("product.展开SKU") : $t("product.折叠SKU") }}
            </a>
          </div>
          <div class="c-4 tx-white">
            {{ $t("product.商品分类") }}
          </div>
          <div class="c-3 tx-white">
            {{ $t("product.状态") }}
          </div>
          <div class="c-3 tx-white">
            {{ $t("product.客户反馈") }}
          </div>
          <div class="c-4 tx-white">
            <div class="d-flex">
              <span>{{ $t("product.创建时间") }}</span>
              <a
                href="javascript:;"
                class="mg-l-5 sp-dd d-inline-block"
                :class="{
                  'tx-info': sortType2 == 'timeCreated',
                  'tx-gray-500': sortType2 != 'timeCreated',
                  up: sorts2 == 'timeCreated ASC',
                }"
                @click="sortList('timeCreated')"
                data-toggle="tooltip"
                data-placement="right"
                :data-original-title="$t('product.按创建时间排序')"
                >▼</a
              >
              <span class="mg-l-2 mg-r-2">/</span>
              <span>{{ $t("product.更新时间") }}</span>
              <a
                href="javascript:;"
                class="mg-l-5 sp-dd d-inline-block"
                :class="{
                  'tx-info': sortType2 == 'timeUpdate',
                  'tx-gray-500': sortType2 != 'timeUpdate',
                  up: sorts2 == 'timeUpdate ASC',
                }"
                @click="sortList('timeUpdate')"
                data-toggle="tooltip"
                data-placement="right"
                :data-original-title="$t('product.按更新时间排序')"
                >▼</a
              >
            </div>
          </div>
          <div class="c-2 tx-white">
            {{ $t("product.操作") }}
          </div>
        </div>
      </div>
      <!-- end header @scroll="scrollEvent"-->
      <div class="body-wrap" id="bodyWarp">
        <div class="body-content">
          <div
            class="list-body d-flex mg-b-10"
            v-if="$store.state.distributorDataDemo"
            data-type="demo"
          >
            <div class="flex-1 pd-x-5 product-table">
              <div class="card bd-gray-400 pd-5">
                <div
                  class="
                    d-flex
                    flex-row
                    align-items-center
                    justify-content-start
                    flex-1
                  "
                >
                  <div class="c-8">
                    <div class="pro align-items-center">
                      <div class="pd-0 d-flex justify-content-center">
                        <label class="ckbox mg-b-0">
                          <input type="checkbox" /><span></span>
                        </label>
                      </div>
                      <a
                        data-v-721d4d09=""
                        href="javascript:;"
                        class="img-wrap mg-r-15"
                        data-src="https://cbu01.alicdn.com/img/ibank/2018/150/477/8859774051_304299419.jpg"
                        lazy="loaded"
                        style="
                          background-image: url('https://cbu01.alicdn.com/img/ibank/2018/150/477/8859774051_304299419.jpg');
                        "
                      ></a>
                      <div data-v-721d4d09="" class="info">
                        <div
                          data-v-721d4d09=""
                          class="mg-b-0 tx-white tx-ellipsis2"
                        >
                          {{ $t("product.测试商品1") }}
                        </div>
                        <div data-v-721d4d09="" class="mg-b-0 d-flex">
                          <span data-v-721d4d09="">{{
                            $t("product.商品货号(SPU)：")
                          }}</span>
                          <span data-v-721d4d09="" class="tx-white"
                            >testSku111</span
                          >
                        </div>
                        <div data-v-721d4d09="" class="mg-b-0 d-flex">
                          <span data-v-721d4d09="">{{
                            $t("product.供货价：")
                          }}</span>
                          <span data-v-721d4d09="" class="tx-white"
                            >￥2.33 - ￥30.00</span
                          >
                        </div>
                        <div data-v-721d4d09="" class="mg-b-0 d-flex">
                          <span data-v-721d4d09="">{{
                            $t("product.包含颜色：")
                          }}</span>
                          <span data-v-721d4d09="" class="tx-white">{{
                            $t("product.红色")
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-v-721d4d09="" class="c-4">
                    <div data-v-721d4d09="" class="mg-b-0 d-flex">
                      <span data-v-721d4d09="" class="tx-white"
                        >-{{ $t("product.日用百货") }}-{{
                          $t("product.烘焙用具")
                        }}-{{ $t("product.烘焙刮刀") }}-</span
                      >
                    </div>
                  </div>
                  <div data-v-721d4d09="" class="c-3">
                    <span data-v-721d4d09="" class="tx-warning">{{
                      $t("product.草稿箱")
                    }}</span>
                  </div>
                  <div data-v-721d4d09="" class="c-3">
                    <a data-v-721d4d09="" href="javascript:;"
                      ><i
                        data-v-721d4d09=""
                        class="icon ion-chatbox-working tx-20 tx-gray-600"
                      ></i
                    ></a>
                  </div>
                  <div data-v-721d4d09="" class="c-4">
                    <span data-v-721d4d09="" class="tx-warning">{{
                      $t("product.草稿箱")
                    }}</span>
                  </div>
                  <div data-v-721d4d09="" class="c-2">
                    <div data-v-721d4d09="" class="mg-b-5">
                      <a
                        data-v-721d4d09=""
                        href="javascript:;"
                        class="tx-info"
                        >{{ $t("product.推送给客户") }}</a
                      >
                    </div>
                    <div data-v-721d4d09="" class="mg-b-5">
                      <a
                        data-v-721d4d09=""
                        href="#/create-pro?sku=213433"
                        class="tx-info"
                        target="_blank"
                        >{{ $t("product.修改") }}</a
                      >
                    </div>
                    <div data-v-721d4d09="">
                      <a
                        data-v-721d4d09=""
                        href="javascript:;"
                        class="tx-danger"
                        >{{ $t("product.删除") }}</a
                      >
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-center mg-y-10">
                  <div class="flex-1"></div>
                  <div
                    role="alert"
                    class="
                      alert alert-warning
                      pd-x-10 pd-y-5
                      mg-b-0
                      wd-50p
                      d-flex
                      justify-content-center
                    "
                  >
                    {{ $t("product.上条数据是演示数据。为配合新手教程使用。") }}
                    <a
                      @click="$root.$children[0].removeDemo"
                      href="javascript:;"
                      class="mg-l-15 tx-info"
                      >{{ $t("product.隐藏演示数据") }}</a
                    >
                  </div>
                  <div data-v-0d4a1ab6="" class="flex-1"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="list-body mg-b-10"
            v-for="(item, index) in items"
            :key="item.id"
            :data-itemid="item.id"
          >
            <div class="pd-x-5 product-table">
              <div class="card bd-gray-400 pd-5">
                <div
                  class="
                    d-flex
                    flex-row
                    align-items-center
                    justify-content-start
                    flex-1
                  "
                >
                  <div class="c-8" style="padding-left: 0">
                    <div class="pro align-items-center">
                      <div class="pd-0 d-flex justify-content-center">
                        <label class="ckbox mg-b-0">
                          <input
                            type="checkbox"
                            :value="item.sku"
                            v-model="checkArr"
                          /><span></span>
                        </label>
                      </div>
                      <div
                        class="mg-l-5 pos-relative"
                        :class="
                          !isEmpty(item.imgUrlJson) &&
                          imgUrlFormat(item.imgUrlJson).length > 1
                            ? 'mg-r-10'
                            : 'mg-r-5'
                        "
                      >
                        <!-- v-if="!isEmpty(item.majorImgUrl)"-->
                        <template>
                          <div
                            v-if="
                              !isEmpty(item.imgUrlJson) &&
                              imgUrlFormat(item.imgUrlJson).length > 1
                            "
                            class="num"
                          >
                            {{ imgUrlFormat(item.imgUrlJson).length }}
                          </div>
                          <a
                            v-if="isEmpty(item.imgUrlJson)"
                            class="p-img-wrap"
                            :class="{ isIll: $isIll(item.majorImgUrl) }"
                            v-lazy:background-image="item.majorImgUrl"
                            href="javascript:;"
                            @click="preview(item.majorImgUrl, item.name)"
                          >
                          </a>
                          <a
                            v-if="!isEmpty(item.imgUrlJson)"
                            class="p-img-wrap"
                            :class="{ isIll: $isIll(item.majorImgUrl) }"
                            v-lazy:background-image="item.majorImgUrl"
                            href="javascript:;"
                            @click="previewMore(item.imgUrlJson, item.name)"
                          >
                          </a>
                        </template>
                        <div
                          v-if="
                            !isEmpty(item.imgUrlJson) &&
                            imgUrlFormat(item.imgUrlJson).length > 1
                          "
                          class="mult-img-bg"
                        ></div>
                        <a
                          v-if="item.status != 2 && item.status != 3"
                          @click="mgrImg(item)"
                          href="javascript:;"
                          class="
                            img-mgr
                            btn btn-primary btn-sm
                            tx-12
                            pos-absolute
                            op-7
                          "
                        >
                          {{ $t("product.图片管理") }}
                        </a>
                      </div>
                      <div class="info">
                        <div class="mg-b-0 tx-white tx-ellipsis2">
                          <a
                            v-if="
                              item.shopDetailUrl && item.shopDetailUrl != ''
                            "
                            :href="item.shopDetailUrl"
                            target="_blank"
                            class="tx-info"
                            >{{ item.name }}</a
                          >
                          <p v-else class="mg-b-0 tx-white">{{ item.name }}</p>
                        </div>
                        <div>
                          <a
                            v-if="item.fromUrl"
                            class="mg-l-5 tx-info"
                            :href="item.fromUrl"
                            target="_blank"
                            >{{ $t("product.原链接") }}</a
                          >
                        </div>
                        <div class="mg-b-0 d-flex">
                          <span>{{ $t("product.商品货号(SPU)：") }}</span>
                          <span class="tx-white">{{
                            item.sku ? item.sku : "--"
                          }}</span>
                        </div>
                        <div class="mg-b-0 d-flex">
                          <span>{{ $t("product.供货价：") }}</span>
                          <span class="tx-white"
                            >{{ ($CE[item.currency] || {}).symbol
                            }}{{
                              item.min ? Number(item.min).toFixed(2) : "0.00"
                            }}
                            - {{ ($CE[item.currency] || {}).symbol
                            }}{{
                              item.max ? Number(item.max).toFixed(2) : "0.00"
                            }}</span
                          >
                        </div>
                        <div
                          v-if="
                            item.pid != undefined && userinfo.productStyle == 2
                          "
                          class="mg-b-0 d-flex"
                        >
                          <span>PID：</span>
                          <span class="tx-white">{{
                            item.pid ? item.pid : "---"
                          }}</span>
                        </div>
                        <div class="mg-b-0 d-flex">
                          <span style="min-width: 65px">{{
                            $t("product.包含颜色：")
                          }}</span>
                          <span class="tx-white">{{ item.colors }}</span>
                        </div>
                        <div
                          v-if="!(userinfo.productStyle == 9999)"
                          class="mg-b-0 d-flex"
                        >
                          <span>{{ $t("product.销售状态：") }}</span>
                          <span :class="statusStyle[item.productStatus]">
                            {{ $t($dict.newProSoldStatus[item.productStatus]) }}
                          </span>
                        </div>
                        <div
                          v-if="item.productStatus == 1"
                          class="mg-b-0 d-flex"
                        >
                          <span>{{ $t("product.上架时间：") }}</span>
                          <span class="tx-white">{{
                            item.timeOff ? timeOff : "---"
                          }}</span>
                        </div>
                        <div
                          v-if="item.productStatus == 2"
                          class="mg-b-0 d-flex"
                        >
                          <span>{{ $t("product.下架时间：") }}</span>
                          <span class="tx-white">{{
                            item.timeSale ? timeSale : "---"
                          }}</span>
                        </div>
                        <div class="mg-b-0 d-flex">
                          <span>{{ $t("product.最后更新时间：") }}</span>
                          <span class="tx-white">{{
                            item.timeUpdate ? item.timeUpdate : "---"
                          }}</span>
                        </div>
                        <div class="pd-5 pd-l-0">
                          <a
                            v-if="
                              item.categoryTags && item.categoryTags.length > 0
                            "
                            class="tx-info mg-r-20"
                            href="javascript:;"
                            @mouseenter="
                              popContact($event, index, 'categoryTags')
                            "
                            @mouseleave="popContact($event)"
                          >
                            <span
                              style="
                                padding: 1px 2px;
                                border: 1px solid rgb(23, 162, 184);
                                font-size: 12px;
                              "
                              >{{ $t("product.标签") }}</span
                            >
                          </a>
                          <a
                            v-if="item.stocks && item.stocks.length > 0"
                            href="javascript:;"
                            @click="innerTableStatus(index)"
                          >
                            <i
                              class="fa tx-white mg-r-10"
                              :class="
                                openInner[index]
                                  ? 'fa-minus-square'
                                  : 'fa-plus-square'
                              "
                            ></i>
                            <span class="tx-white"
                              >{{ $t("product.共") }}
                              <span class="tx-info tx-bold">{{
                                item.stocks.length
                              }}</span>
                              {{ $t("product.个") }}SKU</span
                            >
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="c-4">
                    <div class="mg-b-0 d-flex">
                      <span class="tx-white">{{
                        item.categoryName ? item.categoryName : "---"
                      }}</span>
                    </div>
                  </div>
                  <div class="c-3">
                    <span :class="item.status | statusClass">{{
                      $t($dict.newProStatus[item.status])
                    }}</span>
                  </div>
                  <!-- 客户反馈 -->
                  <div class="c-3">
                    <template v-if="userinfo.productStyle == 2">
                      <a
                        v-if="item.reason && item.reason.length"
                        class="pd-5 tx-info"
                        href="javascript:;"
                        data-container="body"
                        data-toggle="tooltip-primary"
                        data-placement="top"
                        data-html="true"
                        :data-original-title="remarkFormat(item.reason)"
                      >
                        <i class="icon ion-chatbox-working tx-20 tx-info"></i>
                      </a>
                      <a v-else href="javascript:;">
                        <i
                          class="icon ion-chatbox-working tx-20 tx-gray-600"
                        ></i>
                      </a>
                    </template>
                    <template v-else>
                      <a
                        v-if="
                          (item.status == 2 ||
                            item.status == 3 ||
                            item.status == 4) &&
                          isSysRights('NewProduct.getNewProductFeedback')
                        "
                        class="tx-info"
                        href="javascript:;"
                      >
                        <router-link
                          class="tx-info"
                          :to="{
                            path: '/clientFeedback',
                            query: { id: item.id, skuName: item.name },
                          }"
                          target="_blank"
                          ><i class="icon ion-chatbox-working tx-20 tx-info"></i
                        ></router-link>
                      </a>
                      <a v-else href="javascript:;">
                        <i
                          class="icon ion-chatbox-working tx-20 tx-gray-600"
                        ></i>
                      </a>
                    </template>
                  </div>
                  <div class="c-4">
                    <div class="tx-white">
                      <span class="tx-gray-600">{{
                        $t("product.创建时间：")
                      }}</span>
                      {{ item.timeCreated }}
                    </div>
                    <div class="tx-white">
                      <span class="tx-gray-600">{{
                        $t("product.更新时间：")
                      }}</span>
                      {{ item.timeUpdate }}
                    </div>
                  </div>
                  <div class="c-2">
                    <div
                      class="mg-b-5"
                      v-if="isSysRights('NewProduct.pushNewProduct')"
                    >
                      <a
                        v-if="item.status == 1"
                        class="tx-info"
                        href="javascript:;"
                        @click="channelType(item)"
                        >{{ $t("product.推送给客户") }}</a
                      >
                    </div>
                    <div
                      v-if="
                        userinfo.productStyle == 1 ||
                        userinfo.productStyle == 9999
                      "
                      class="mg-b-5"
                    >
                      <router-link
                        class="tx-info"
                        target="_blank"
                        :to="{ name: 'createPro', query: { sku: item.sku } }"
                        >{{ $t("product.修改") }}</router-link
                      >
                    </div>
                    <div
                      v-if="
                        item.status != 2 &&
                        item.status != 3 &&
                        userinfo.productStyle == 2
                      "
                      class="mg-b-5"
                    >
                      <router-link
                        class="tx-info"
                        target="_blank"
                        :to="{
                          name: 'createPro2',
                          query: { sku: item.sku, cate: item.categoryId1688 },
                        }"
                        >{{ $t("product.修改") }}</router-link
                      >
                    </div>
                    <div
                      v-if="
                        item.status != 2 && item.status != 3 && item.status != 9
                      "
                    >
                      <a
                        class="tx-danger"
                        href="javascript:;"
                        @click="delNewProduct(item)"
                        >{{ $t("product.作废") }}</a
                      >
                    </div>
                    <div v-if="item.status == '9'">
                      <a
                        class="tx-danger"
                        href="javascript:;"
                        @click="delNewProduct(item)"
                        >{{ $t("product.删除") }}</a
                      >
                    </div>
                  </div>
                </div>
                <template v-if="item.stocks && item.stocks.length > 0">
                  <!--@scroll="scrollEventLeft(index)"-->
                  <div
                    :id="'scrollLeftWrap' + index"
                    v-show="openInner[index]"
                    class="tx-white"
                    style="padding: 10px 0 10px 105px"
                    :class="
                      item.stocks[0].itemSpecific &&
                      item.stocks[0].itemSpecific.length > 3
                        ? 'overflow'
                        : ''
                    "
                  >
                    <table
                      class="
                        table
                        mg-b-0
                        table-contact
                        bill
                        data-table
                        tableWrapFixed
                      "
                      :id="'tableWrapFixed' + index"
                      style="
                        position: fixed;
                        top: 200px;
                        z-index: 4;
                        display: none;
                        left: 437px;
                      "
                    >
                      <thead>
                        <tr>
                          <th
                            v-if="
                              item.pid != undefined &&
                              userinfo.productStyle == 2
                            "
                          >
                            HSKU
                            <a
                              @click="sortItemNew('pid', index)"
                              href="javascript:;"
                              class="mg-l-5 sp-dd d-inline-block"
                              :class="{
                                'tx-info': item.sortType == 'pid',
                                'tx-gray-500': item.sortType != 'pid',
                                up:
                                  item.sortType == 'pid' && item.sorts == 'ASC',
                              }"
                              >▼</a
                            >
                          </th>
                          <th>{{ $t("product.图片") }}</th>
                          <th>
                            {{ $t("product.颜色")
                            }}<a
                              @click="sortItemNew('color', index)"
                              href="javascript:;"
                              class="mg-l-5 sp-dd d-inline-block"
                              :class="{
                                'tx-info': item.sortType == 'color',
                                'tx-gray-500': item.sortType != 'color',
                                up:
                                  item.sortType == 'color' &&
                                  item.sorts == 'ASC',
                              }"
                              >▼</a
                            >
                          </th>
                          <th>
                            {{ $t("product.尺码")
                            }}<a
                              @click="sortItemNew('size', index)"
                              href="javascript:;"
                              class="mg-l-5 sp-dd d-inline-block"
                              :class="{
                                'tx-info': item.sortType == 'size',
                                'tx-gray-500': item.sortType != 'size',
                                up:
                                  item.sortType == 'size' &&
                                  item.sorts == 'ASC',
                              }"
                              >▼</a
                            >
                          </th>
                          <th>
                            {{ $t("product.商品单品货号") }}(SKU)<a
                              @click="sortItemNew('sku', index)"
                              href="javascript:;"
                              class="mg-l-5 sp-dd d-inline-block"
                              :class="{
                                'tx-info': item.sortType == 'sku',
                                'tx-gray-500': item.sortType != 'sku',
                                up:
                                  item.sortType == 'sku' && item.sorts == 'ASC',
                              }"
                              >▼</a
                            >
                          </th>
                          <!--<th>$t('product.库存数量')</th>-->
                          <th>
                            {{ $t("product.供货价") }}
                            <a
                              @click="sortItemNew('price', index)"
                              href="javascript:;"
                              class="mg-l-5 sp-dd d-inline-block"
                              :class="{
                                'tx-info': item.sortType == 'price',
                                'tx-gray-500': item.sortType != 'price',
                                up:
                                  item.sortType == 'price' &&
                                  item.sorts == 'ASC',
                              }"
                              >▼</a
                            >
                          </th>
                          <template
                            v-if="
                              item.stocks[0].itemSpecific &&
                              item.stocks[0].itemSpecific.length
                            "
                          >
                            <template
                              v-for="(itemSpec, index) in item.stocks[0]
                                .itemSpecific"
                            >
                              <th
                                :key="index"
                                v-if="
                                  itemSpec.name !=
                                  'descriptionOrAccessoriesDescription'
                                "
                              >
                                <span v-html="getHtml(itemSpec.vName)"></span>
                                <a
                                  @click="sortItemNew(itemSpec.name, index)"
                                  href="javascript:;"
                                  class="mg-l-5 sp-dd d-inline-block"
                                  :class="{
                                    'tx-info': item.sortType == itemSpec.name,
                                    'tx-gray-500':
                                      item.sortType != itemSpec.name,
                                    up:
                                      item.sortType == itemSpec.name &&
                                      item.sorts == 'ASC',
                                  }"
                                  >▼</a
                                >
                              </th>
                            </template>
                          </template>
                        </tr>
                      </thead>
                      <tbody style="opacity: 0">
                        <template v-for="(obj, subIndex) in item.stocks">
                          <tr :key="obj.id" v-if="subIndex == 0">
                            <td
                              v-if="
                                item.pid != undefined &&
                                userinfo.productStyle == 2
                              "
                              class="valign-middle"
                            >
                              {{ obj.hSku ? obj.hSku : "---" }}
                              <a
                                v-show="obj.hSku"
                                class="to-clipboard tx-info mg-l-5"
                                href="javascript:;"
                                :data-clipboard-text="obj.hSku"
                              >
                                <i class="icon ion-clipboard"></i>
                              </a>
                            </td>
                            <td class="valign-middle">
                              <div
                                class="pos-relative"
                                style="
                                  min-width: 80px;
                                  width: 80px;
                                  height: 60px;
                                "
                              >
                                <a
                                  style="
                                    border: 1px solid #ddd;
                                    margin: 0 10px;
                                    display: block;
                                    min-width: 60px;
                                    width: 60px;
                                    height: 60px;
                                    background-size: cover;
                                    background-position: center;
                                  "
                                  class="img-wrap mg-r-15"
                                  :class="{ isIll: $isIll(obj.propertyImage) }"
                                  v-lazy:background-image="obj.propertyImage"
                                  href="javascript:;"
                                  @click="preview(obj.propertyImage, obj.name)"
                                >
                                </a>
                                <a
                                  v-if="item.status != 2 && item.status != 3"
                                  @click="mgrImg(item, obj.sku, 1)"
                                  href="javascript:;"
                                  class="
                                    img-mgr
                                    btn btn-primary btn-sm
                                    tx-12
                                    pos-absolute
                                    op-7
                                  "
                                >
                                  {{ $t("product.图片管理") }}
                                </a>
                              </div>
                            </td>
                            <td class="valign-middle tx-white">
                              {{
                                obj.propertyValue
                                  ? obj.propertyValue.split("||")[0]
                                  : "---"
                              }}
                            </td>
                            <td class="valign-middle tx-white">
                              {{
                                obj.propertyValue
                                  ? obj.propertyValue.split("||")[1]
                                  : "---"
                              }}
                            </td>
                            <td class="valign-middle tx-white">
                              {{ obj.sku ? obj.sku : "---" }}
                              <a
                                v-show="obj.sku"
                                class="to-clipboard tx-info mg-l-5"
                                href="javascript:;"
                                :data-clipboard-text="obj.sku"
                              >
                                <i class="icon ion-clipboard"></i>
                              </a>
                            </td>
                            <td class="valign-middle tx-white">
                              {{
                                obj.salePrice
                                  ? $CE[item.currency].symbol +
                                    Number(obj.salePrice).toFixed(2)
                                  : "0.00"
                              }}
                            </td>
                            <template
                              v-if="obj.itemSpecific && obj.itemSpecific.length"
                            >
                              <template
                                v-for="(itemSpec, index) in obj.itemSpecific"
                              >
                                <td
                                  :key="index"
                                  class="valign-middle tx-white"
                                  v-if="
                                    itemSpec.name !=
                                    'descriptionOrAccessoriesDescription'
                                  "
                                >
                                  {{ itemSpec.value }}
                                </td>
                              </template>
                            </template>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                    <table
                      class="
                        table
                        mg-b-0
                        table-contact2
                        bill
                        data-table
                        tableWrap
                      "
                      :id="'tableWrap' + index"
                    >
                      <thead>
                        <tr>
                          <th
                            v-if="
                              item.pid != undefined &&
                              userinfo.productStyle == 2
                            "
                          >
                            HSKU
                            <a
                              @click="sortItemNew('pid', index)"
                              href="javascript:;"
                              class="mg-l-5 sp-dd d-inline-block"
                              :class="{
                                'tx-info': item.sortType == 'pid',
                                'tx-gray-500': item.sortType != 'pid',
                                up:
                                  item.sortType == 'pid' && item.sorts == 'ASC',
                              }"
                              >▼</a
                            >
                          </th>
                          <th>{{ $t("product.图片") }}</th>
                          <th>
                            {{ $t("product.颜色")
                            }}<a
                              @click="sortItemNew('color', index)"
                              href="javascript:;"
                              class="mg-l-5 sp-dd d-inline-block"
                              :class="{
                                'tx-info': item.sortType == 'color',
                                'tx-gray-500': item.sortType != 'color',
                                up:
                                  item.sortType == 'color' &&
                                  item.sorts == 'ASC',
                              }"
                              >▼</a
                            >
                          </th>
                          <th>
                            {{ $t("product.尺码")
                            }}<a
                              @click="sortItemNew('size', index)"
                              href="javascript:;"
                              class="mg-l-5 sp-dd d-inline-block"
                              :class="{
                                'tx-info': item.sortType == 'size',
                                'tx-gray-500': item.sortType != 'size',
                                up:
                                  item.sortType == 'size' &&
                                  item.sorts == 'ASC',
                              }"
                              >▼</a
                            >
                          </th>
                          <th>
                            {{ $t("product.商品单品货号") }}(SKU)<a
                              @click="sortItemNew('sku', index)"
                              href="javascript:;"
                              class="mg-l-5 sp-dd d-inline-block"
                              :class="{
                                'tx-info': item.sortType == 'sku',
                                'tx-gray-500': item.sortType != 'sku',
                                up:
                                  item.sortType == 'sku' && item.sorts == 'ASC',
                              }"
                              >▼</a
                            >
                          </th>
                          <!--<th>$t('product.库存数量')</th>-->
                          <th>
                            {{ $t("product.供货价") }}
                            <a
                              @click="sortItemNew('price', index)"
                              href="javascript:;"
                              class="mg-l-5 sp-dd d-inline-block"
                              :class="{
                                'tx-info': item.sortType == 'price',
                                'tx-gray-500': item.sortType != 'price',
                                up:
                                  item.sortType == 'price' &&
                                  item.sorts == 'ASC',
                              }"
                              >▼</a
                            >
                          </th>
                          <template
                            v-if="
                              item.stocks[0].itemSpecific &&
                              item.stocks[0].itemSpecific.length
                            "
                          >
                            <template
                              v-for="(itemSpec, index) in item.stocks[0]
                                .itemSpecific"
                            >
                              <th
                                :key="index"
                                v-if="
                                  itemSpec.name !=
                                  'descriptionOrAccessoriesDescription'
                                "
                              >
                                <span v-html="getHtml(itemSpec.vName)"></span>
                                <a
                                  @click="sortItemNew(itemSpec.name, index)"
                                  href="javascript:;"
                                  class="mg-l-5 sp-dd d-inline-block"
                                  :class="{
                                    'tx-info': item.sortType == itemSpec.name,
                                    'tx-gray-500':
                                      item.sortType != itemSpec.name,
                                    up:
                                      item.sortType == itemSpec.name &&
                                      item.sorts == 'ASC',
                                  }"
                                  >▼</a
                                >
                              </th>
                            </template>
                          </template>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="(obj, subIndex) in item.stocks">
                          <tr :key="subIndex">
                            <td
                              v-if="
                                item.pid != undefined &&
                                userinfo.productStyle == 2
                              "
                              class="valign-middle"
                            >
                              {{ obj.hSku ? obj.hSku : "---" }}
                              <a
                                v-show="obj.hSku"
                                class="to-clipboard tx-info mg-l-5"
                                href="javascript:;"
                                :data-clipboard-text="obj.hSku"
                              >
                                <i class="icon ion-clipboard"></i>
                              </a>
                            </td>
                            <td class="valign-middle">
                              <div
                                class="pos-relative"
                                style="
                                  min-width: 80px;
                                  width: 80px;
                                  height: 60px;
                                "
                              >
                                <a
                                  style="
                                    border: 1px solid #ddd;
                                    margin: 0 10px;
                                    display: block;
                                    min-width: 60px;
                                    width: 60px;
                                    height: 60px;
                                    background-size: cover;
                                    background-position: center;
                                  "
                                  class="img-wrap mg-r-15"
                                  :class="{ isIll: $isIll(obj.propertyImage) }"
                                  v-lazy:background-image="obj.propertyImage"
                                  href="javascript:;"
                                  @click="preview(obj.propertyImage, obj.name)"
                                >
                                </a>
                                <a
                                  v-if="item.status != 2 && item.status != 3"
                                  @click="mgrImg(item, obj.sku, 1)"
                                  href="javascript:;"
                                  class="
                                    img-mgr
                                    btn btn-primary btn-sm
                                    tx-12
                                    pos-absolute
                                    op-7
                                  "
                                >
                                  {{ $t("product.图片管理") }}
                                </a>
                              </div>
                            </td>
                            <td class="valign-middle tx-white">
                              {{
                                obj.propertyValue
                                  ? obj.propertyValue.split("||")[0]
                                  : "---"
                              }}
                            </td>
                            <td class="valign-middle tx-white">
                              {{
                                obj.propertyValue
                                  ? obj.propertyValue.split("||")[1]
                                  : "---"
                              }}
                            </td>
                            <td class="valign-middle tx-white">
                              {{ obj.sku ? obj.sku : "---" }}
                              <a
                                v-show="obj.sku"
                                class="to-clipboard tx-info mg-l-5"
                                href="javascript:;"
                                :data-clipboard-text="obj.sku"
                              >
                                <i class="icon ion-clipboard"></i>
                              </a>
                            </td>
                            <td class="valign-middle tx-white">
                              {{
                                obj.salePrice
                                  ? $CE[item.currency].symbol +
                                    Number(obj.salePrice).toFixed(2)
                                  : "0.00"
                              }}
                            </td>
                            <template
                              v-if="obj.itemSpecific && obj.itemSpecific.length"
                            >
                              <template
                                v-for="(itemSpec, sindex) in obj.itemSpecific"
                              >
                                <td
                                  :key="sindex"
                                  class="valign-middle tx-white"
                                  v-if="
                                    itemSpec.name !=
                                    'descriptionOrAccessoriesDescription'
                                  "
                                >
                                  {{ itemSpec.value }}
                                </td>
                              </template>
                            </template>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                    <div v-if="false">
                      <div class="d-flex">
                        <div
                          v-if="
                            item.pid != undefined && userinfo.productStyle == 2
                          "
                        >
                          HSKU
                          <a
                            @click="sortItemNew('pid', index)"
                            href="javascript:;"
                            class="mg-l-5 sp-dd d-inline-block"
                            :class="{
                              'tx-info': item.sortType == 'pid',
                              'tx-gray-500': item.sortType != 'pid',
                              up: item.sortType == 'pid' && item.sorts == 'ASC',
                            }"
                            >▼</a
                          >
                        </div>
                        <div>{{ $t("product.图片") }}</div>
                        <div>
                          {{ $t("product.颜色")
                          }}<a
                            @click="sortItemNew('color', index)"
                            href="javascript:;"
                            class="mg-l-5 sp-dd d-inline-block"
                            :class="{
                              'tx-info': item.sortType == 'color',
                              'tx-gray-500': item.sortType != 'color',
                              up:
                                item.sortType == 'color' && item.sorts == 'ASC',
                            }"
                            >▼</a
                          >
                        </div>
                        <div>
                          {{ $t("product.尺码")
                          }}<a
                            @click="sortItemNew('size', index)"
                            href="javascript:;"
                            class="mg-l-5 sp-dd d-inline-block"
                            :class="{
                              'tx-info': item.sortType == 'size',
                              'tx-gray-500': item.sortType != 'size',
                              up:
                                item.sortType == 'size' && item.sorts == 'ASC',
                            }"
                            >▼</a
                          >
                        </div>
                        <div>
                          {{ $t("product.商品单品货号") }}(SKU)<a
                            @click="sortItemNew('sku', index)"
                            href="javascript:;"
                            class="mg-l-5 sp-dd d-inline-block"
                            :class="{
                              'tx-info': item.sortType == 'sku',
                              'tx-gray-500': item.sortType != 'sku',
                              up: item.sortType == 'sku' && item.sorts == 'ASC',
                            }"
                            >▼</a
                          >
                        </div>
                        <!--<th>$t('product.库存数量')</th>-->
                        <div>
                          {{ $t("product.供货价") }}
                          <a
                            @click="sortItemNew('price', index)"
                            href="javascript:;"
                            class="mg-l-5 sp-dd d-inline-block"
                            :class="{
                              'tx-info': item.sortType == 'price',
                              'tx-gray-500': item.sortType != 'price',
                              up:
                                item.sortType == 'price' && item.sorts == 'ASC',
                            }"
                            >▼</a
                          >
                        </div>
                        <template
                          v-if="
                            item.stocks[0].itemSpecific &&
                            item.stocks[0].itemSpecific.length
                          "
                        >
                          <template
                            v-for="(itemSpec, sindex) in item.stocks[0]
                              .itemSpecific"
                          >
                            <div
                              :key="sindex"
                              v-if="
                                itemSpec.name !=
                                'descriptionOrAccessoriesDescription'
                              "
                            >
                              <span v-html="getHtml(itemSpec.vName)"></span>
                              <a
                                @click="sortItemNew(itemSpec.name, index)"
                                href="javascript:;"
                                class="mg-l-5 sp-dd d-inline-block"
                                :class="{
                                  'tx-info': item.sortType == itemSpec.name,
                                  'tx-gray-500': item.sortType != itemSpec.name,
                                  up:
                                    item.sortType == itemSpec.name &&
                                    item.sorts == 'ASC',
                                }"
                                >▼</a
                              >
                            </div>
                          </template>
                        </template>
                      </div>
                      <div>
                        <div v-for="obj in item.stocks" :key="obj.id">
                          <div
                            v-if="
                              item.pid != undefined &&
                              userinfo.productStyle == 2
                            "
                            class="valign-middle"
                          >
                            {{ obj.hSku ? obj.hSku : "---" }}
                            <a
                              v-show="obj.hSku"
                              class="to-clipboard tx-info mg-l-5"
                              href="javascript:;"
                              :data-clipboard-text="obj.hSku"
                            >
                              <i class="icon ion-clipboard"></i>
                            </a>
                          </div>
                          <div class="valign-middle">
                            <div
                              class="pos-relative"
                              style="min-width: 80px; width: 80px; height: 60px"
                            >
                              <a
                                style="
                                  border: 1px solid #ddd;
                                  margin: 0 10px;
                                  display: block;
                                  min-width: 60px;
                                  width: 60px;
                                  height: 60px;
                                  background-size: cover;
                                  background-position: center;
                                "
                                class="img-wrap mg-r-15"
                                v-lazy:background-image="obj.propertyImage"
                                href="javascript:;"
                                @click="preview(obj.propertyImage, obj.name)"
                              >
                              </a>
                              <a
                                v-if="item.status != 2 && item.status != 3"
                                @click="mgrImg(item, obj.sku, 1)"
                                href="javascript:;"
                                class="
                                  img-mgr
                                  btn btn-primary btn-sm
                                  tx-12
                                  pos-absolute
                                  op-7
                                "
                              >
                                {{ $t("product.图片管理") }}
                              </a>
                            </div>
                          </div>
                          <div class="valign-middle tx-white">
                            {{
                              obj.propertyValue
                                ? obj.propertyValue.split("||")[0]
                                : "---"
                            }}
                          </div>
                          <div class="valign-middle tx-white">
                            {{
                              obj.propertyValue
                                ? obj.propertyValue.split("||")[1]
                                : "---"
                            }}
                          </div>
                          <div class="valign-middle tx-white">
                            {{ obj.sku ? obj.sku : "---" }}
                            <a
                              v-show="obj.sku"
                              class="to-clipboard tx-info mg-l-5"
                              href="javascript:;"
                              :data-clipboard-text="obj.sku"
                            >
                              <i class="icon ion-clipboard"></i>
                            </a>
                          </div>
                          <div class="valign-middle tx-white">
                            {{
                              obj.salePrice
                                ? ($CE[item.currency] || {}).symbol +
                                  Number(obj.salePrice).toFixed(2)
                                : "0.00"
                            }}
                          </div>
                          <template
                            v-if="obj.itemSpecific && obj.itemSpecific.length"
                          >
                            <template
                              v-for="(itemSpec, index) in obj.itemSpecific"
                            >
                              <div
                                :key="index"
                                class="valign-middle tx-white"
                                v-if="
                                  itemSpec.name !=
                                  'descriptionOrAccessoriesDescription'
                                "
                              >
                                {{ itemSpec.value }}
                              </div>
                            </template>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="(!items || items.length < 1) && !first_loading">
      <div colspan="5">
        <div class="col-12 none-product">
          <i class="fa fa-ban"></i>{{ $t("product.没有符合条件的新品推荐") }}
        </div>
      </div>
    </div>
    <Modal
      :modalId="'modalHotProduct'"
      :home="false"
      :loading="modalHotProduct.loading"
      :size="'md'"
      :autoH="false"
    >
      <template slot="header">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("product.展示次数详情：") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </template>
      <template slot="body">
        <div class="body-inner">
          <table class="table table-contact table-striped tx-12">
            <thead>
              <tr>
                <td class="border-top-0">{{ $t("product.客户名") }}</td>
                <td class="border-top-0">{{ $t("product.查看时间") }}</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in modalHotProduct.items" :key="item.id">
                <td>{{ item.distributorName }}</td>
                <td>{{ item.timeCreated }}</td>
              </tr>
            </tbody>
          </table>
          <div
            v-if="modalHotProduct.items.length > 0"
            class="
              inner-pagination
              d-flex
              align-items-center
              justify-content-center
            "
          >
            <nav aria-label="Page navigation">
              <ul class="pagination pagination-basic mg-b-0">
                <li v-if="showFirst" class="page-item" @click="modalGoto(1)">
                  <a href="javascript:;" class="page-link"
                    ><i class="fa fa-angle-double-left"></i
                  ></a>
                </li>
                <li
                  v-if="showFirst"
                  class="page-item"
                  @click="modalGoto(parseInt(modalHotProduct.page) - 1)"
                >
                  <a
                    href="javascript:;"
                    class="page-link wd-60"
                    style="white-space: nowrap; width: auto !important"
                    >{{ $t("product.前一页") }}</a
                  >
                </li>
                <li
                  v-for="index in indexs"
                  :key="index"
                  class="page-item"
                  :class="{ active: modalHotProduct.page == index }"
                  @click="modalGoto(index)"
                >
                  <a href="javascript:;" class="page-link">{{ index }}</a>
                </li>
                <li
                  v-if="showLast"
                  class="page-item"
                  @click="modalGoto(parseInt(modalHotProduct.page) + 1)"
                >
                  <a href="javascript:;" class="page-link wd-60">{{
                    $t("product.后一页")
                  }}</a>
                </li>
                <li
                  v-if="showLast"
                  class="page-item"
                  @click="modalGoto(modalHotProduct.totalPage)"
                >
                  <a href="javascript:;" class="page-link"
                    ><i class="fa fa-angle-double-right"></i
                  ></a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="modal-footer d-block pd-y-15 pd-x-0">
          <div
            class="
              form-group
              row
              align-items-center
              justify-content-end
              pd-x-25
              mg-b-0
            "
          >
            <button
              type="button"
              class="
                btn btn-secondary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              data-dismiss="modal"
            >
              {{ $t("product.关闭") }}
            </button>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from "@components/Modal";
export default {
  props: [
    "items",
    "first_loading",
    "isAccordion",
    "check_arr",
    "sort",
    "sort_type",
    "sort_i",
    "sort2",
    "sort_type2",
    "_page",
  ],
  data() {
    return {
      modalHotProduct: {
        loading: false,
        id: "",
        page: 1,
        totalPage: 1,
        rowsPerPage: 10,
        items: [],
      },
      modalHotProductDefault: "{}",
      openInner: [],
      checkArr: [],
      userinfo: JSON.parse(localStorage.getItem("userInfo")),
      sorts: "ASC",
      sortType: "sizeInCms",
      sortI: "",
      sorts2: "",
      sortType2: "timeCreated",
      current: 1,
      navIndex: 0,
      statusStyle: {
        1: "tx-success",
        2: "tx-danger",
        9: "tx-warning",
      },
    };
  },
  components: {
    Modal,
  },
  watch: {
    sort_type2: function () {
      this.sortType2 = this.sort_type2;
    },
    sort2: function () {
      this.sorts2 = this.sort2;
    },
    sort_i: function () {
      this.sortI = this.sort_i;
    },
    sort_type: function () {
      this.sortType = this.sort_type;
    },
    sort: function () {
      this.sorts = this.sort;
    },
    check_arr: function () {
      this.checkArr = this.check_arr;
    },
    checkArr: function () {
      this.$emit("changeChecked", this.checkArr);
    },
    isAccordion: function () {
      //$t('product.展开')$t('product.折叠')
      this.openInnerFormat();
    },
    items: {
      handler: function () {
        this.$nextTick(function () {
          if (this.items.length) {
            let bodyH = parseInt($(window).height());
            if (this.$root.$children[0].sideTop) {
              $(".body-wrap").css(
                "height",
                bodyH - 260 - $(".br-subleft").outerHeight() + "px"
              );
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          } else {
            $(".body-wrap").css("height", 0 + "px");
          }
          //		      let bodyH=parseInt($(window).height() );
          //			  	$(".body-wrap").css("height",(bodyH-260)+"px");
          //			  	$(".body-wrap").perfectScrollbar("destroy");
          //			    $(".body-wrap").perfectScrollbar();
        });
      },
      deep: true,
    },
    itemsLength() {
      this.openInnerFormat();
    },
    _page() {
      this.openInnerFormat();
    },
    sideTop() {
      setTimeout(() => {
        let bodyH = parseInt($(window).height());
        if (this.sideTop) {
          $(".body-wrap").css(
            "height",
            bodyH - 260 - $(".br-subleft").outerHeight() + "px"
          );
        } else {
          $(".body-wrap").css("height", bodyH - 260 + "px");
        }
      }, 1000);
    },
  },
  computed: {
    sideTop() {
      return this.$root.$children[0].sideTop;
    },
    itemsLength() {
      return this.items.length;
    },
    isAll() {
      return this.checkArr.length == this.items.length && this.items.length > 0
        ? true
        : false;
    },
    indexs: function () {
      let ar = [];
      let left, right;
      if (this.modalHotProduct.page < 5) {
        for (let i = 1; i < 8; i++) {
          ar.push(i);
          if (i >= this.modalHotProduct.totalPage) break;
        }
      } else {
        left = right = this.modalHotProduct.page;
        for (let i = 0; i < 4; i++) {
          ar.unshift(left--);
          if (left <= 1) break;
        }
        for (let i = 0; i < 3; i++) {
          if (right >= this.modalHotProduct.totalPage) break;
          right++;
          ar.push(right);
        }
      }
      return ar;
    },
    showLast: function () {
      if (this.modalHotProduct.page == this.modalHotProduct.totalPage) {
        return false;
      }
      return true;
    },
    showLastPer: function () {
      if (this.modalHotProduct.totalPage - this.modalHotProduct.page < 10) {
        return false;
      }
      return true;
    },
    showFirst: function () {
      if (this.modalHotProduct.page == 1) {
        return false;
      }
      return true;
    },
    showFirstPer: function () {
      if (this.modalHotProduct.page < 11) {
        return false;
      }
      return true;
    },
  },
  updated() {
    $('[data-toggle="tooltip-primary"]').tooltip({
      template:
        '<div class="tooltip tooltip-primary tooltip-special" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    });
    //  $('.tooltip-primary.tooltip-special').on('shown.bs.tooltip', function () {
    //  	console.log(1)
    //		  $('.tooltip-primary.tooltip-special').css("top","-60px")
    //		})
  },
  filters: {
    statusClass(val) {
      let c = "";
      switch (val) {
        case "1":
          c = "tx-warning";
          break;
        case "2":
        case "3":
          c = "tx-success";
          break;
        case "4":
          c = "tx-danger";
          break;
        case "9":
          c = "tx-white";
          break;
        default:
          break;
      }
      return c;
    },
  },
  mounted() {
    this.modalHotProductDefault = JSON.stringify(this.modalHotProduct);
    let vm = this;
    var p = 0;
    var t = 0;
    //  $(".body-wrap").scroll(() => {
    //  	if (!$(`#tableWrap${this.current - 1}`).offset()) return;
    ////  	console.log($(`#tableWrap${this.current - 1}`).offset().top)
    ////  	return
    //  	p=$(".body-wrap").scrollTop();
    //
    //	    if(t<=p){
    //	      console.log('$t('product.下滚')')
    //	      console.log($(`#tableWrap${this.current - 1}`).offset().top)
    //	      if ($(`#tableWrap${this.current - 1}`).offset().top - 200 <= 0) {
    //	      	this.items.forEach((e,i)=>{
    //		    		$(`#tableWrapFixed${i}`).css("display","none")
    //		    	})
    //			   	$(`#tableWrapFixed${this.current - 1}`).css("display","block")
    //		   		this.current++;
    //		    }
    //	    }
    //	    else{
    //	      console.log('$t('product.上滚')')
    //	      console.log(this.current)
    //	     console.log($(`#tableWrap${this.current - 1}`).offset().top)
    //	      if ($(`#tableWrap${this.current - 1}`).offset().top - 200 <= $(".body-wrap").scrollTop() + $(".body-wrap").innerHeight()) {
    //	      	this.items.forEach((e,i)=>{
    //		    		$(`#tableWrapFixed${i}`).css("display","none")
    //		    	})
    //			   	$(`#tableWrapFixed${this.current - 1}`).css("display","block")
    //		   		this.current--;
    //		    }
    //	    }
    //
    //	    t = p;
    //
    //    var scrollTop = $(".body-wrap").scrollTop();
    //    var ks_area = $(".body-wrap").innerHeight();
    //    var nScrollHight = 0;
    //    nScrollHight = $(".body-wrap")[0].scrollHeight;
    //	    if(scrollTop + ks_area >= nScrollHight){ //$t('product.到底')
    //	    	this.current = 9;
    //      this.items.forEach((e,i)=>{
    //	    		$(`#tableWrapFixed${i}`).css("display","none")
    //	    	})
    //	    }
    //    if($(".body-wrap").scrollTop() ==0){
    //    	this.current = 1;
    //    	this.items.forEach((e,i)=>{
    //	    		$(`#tableWrapFixed${i}`).css("display","none")
    //	    	})
    //    }
    //  });

    //  $('.tooltip-primary.tooltip-special').on('shown.bs.tooltip', function () {
    //		   $('.tooltip-primary.tooltip-special').css("top","-60px")
    //		   console.log(2)
    //		})
  },
  methods: {
    scrollEventLeft(i) {
      //			console.log(div.scrollLeft)
      //			let reg = new RegExp("px","g");
      //			let left = Number(document.getElementById(`tableWrapFixed${i}`).style.left.replace(reg, "")) - Number(div.scrollLeft);
      //			console.log( Number(document.getElementById(`tableWrapFixed${i}`).style.left.replace(reg, "")))

      let div = document.getElementById(`scrollLeftWrap${i}`);
      $(`#tableWrapFixed${i}`).css("left", `${437 - Number(div.scrollLeft)}px`);
    },
    scrollEvent() {
      var div = document.getElementById("bodyWarp");
      var _scrollTop = div.scrollTop;
      var _scrollHeight = div.scrollHeight;
      var _height = div.clientHeight;

      var box = $(".tableWrap");
      //$t('product.滚动条高度')+$t('product.视窗高度') = $t('product.可见区域底部高度')
      var visibleBottom = _scrollTop + _height;
      //$t('product.可见区域顶部高度')
      var visibleTop = _scrollTop;
      for (var q = 0; q < box.length; q++) {
        //		  	console.log(q+":"+(box.eq(q).offset().top-$(".body-wrap").offset().top));

        var centerY =
          box.eq(q).offset().top -
          $(".body-wrap").offset().top +
          box.eq(q).outerHeight();
        var offsetTop = box.eq(q).offset().top - $(".body-wrap").offset().top;
        if (offsetTop <= 0) {
          this.items.forEach((e, i) => {
            $(`#tableWrapFixed${i}`).css("display", "none");
          });
          for (let i = 0; i < $(`#tableWrapFixed${q} tbody td`).length; i++) {
            $(`#tableWrapFixed${q} tbody tr`)
              .eq(0)
              .find("td")
              .eq(i)
              .css({
                width:
                  $(`#tableWrap${q} tbody tr`).eq(0).find("td").eq(i).width() +
                  20,
              });
          }
          $(`#tableWrapFixed${q}`).css("display", "block");
          //			   console.log('$t('product.第')'+q+'$t('product.个')区域可见');
        } else {
          //			   console.log('$t('product.第')'+q+'$t('product.个')区域不可见');
        }
      }

      //			var div = document.getElementById("bodyWarp");
      //	    var ele = document.getElementById(`tableWrap${this.current - 1}`);
      //			var offsetTopIn = ele.offsetTop - div.offsetTop;
      //
      //			var _scrollTop = div.scrollTop;
      //			var _scrollHeight = div.scrollHeight;
      //			var _height = div.clientHeight;
      //			console.log("offsetTop:"+$(`#tableWrap${this.current - 1}`).offset().top);
      //			console.log("scrollTop:"+div.scrollTop);
      //			console.log("scrollHeight:"+div.scrollHeight);
      //			console.log("clientHeight:"+div.clientHeight);
      //			console.log("current:"+this.current);
      //			if(offsetTopIn >= _scrollTop && offsetTopIn <= _scrollTop + _height){
      //			    console.log(true);
      //			}else{
      //				console.log(false);
      //	      if ($(`#tableWrap${this.current - 1}`).offset().top - 200 <= 0) {
      //	      	this.items.forEach((e,i)=>{
      //		    		$(`#tableWrapFixed${i}`).css("display","none")
      //		    	})
      //	      	for (let i =0;i<$(`#tableWrapFixed${this.current - 1} tbody td`).length;i++) {
      //		   			$(`#tableWrapFixed${this.current - 1} tbody tr`).eq(0).find("td").eq(i).css({
      //		   				"width":$(`#tableWrap${this.current - 1} tbody tr`).eq(0).find("td").eq(i).width()+20
      //			   		})
      //			   	}
      //			   	$(`#tableWrapFixed${this.current - 1}`).css("display","block");
      //		   		this.current++;
      //		    }
      //
      //			}
      //
      //	    if(_scrollTop + _height >= _scrollHeight){ //$t('product.到底')
      //	    	this.current = 9;
      //      this.items.forEach((e,i)=>{
      //	    		$(`#tableWrapFixed${i}`).css("display","none")
      //	    	})
      //	    }
      //    if($(".body-wrap").scrollTop() ==0){
      //    	this.current = 1;
      //    	this.items.forEach((e,i)=>{
      //	    		$(`#tableWrapFixed${i}`).css("display","none")
      //	    	})
      //    }
    },
    sortList(type) {
      $('[data-toggle="tooltip"]').tooltip("hide"); //$t('product.关闭')所有 tooltip
      switch (type) {
        case "name":
          if (!this.sorts2) {
            this.sorts2 = "name DESC";
          } else {
            if (this.sorts2 == "name DESC") {
              this.sorts2 = "name ASC";
            } else {
              this.sorts2 = "name DESC";
            }
          }
          break;
        case "timeUpdate":
          if (!this.sorts2) {
            this.sorts2 = "timeUpdate DESC";
          } else {
            if (this.sorts2 == "timeUpdate DESC") {
              this.sorts2 = "timeUpdate ASC";
            } else {
              this.sorts2 = "timeUpdate DESC";
            }
          }
          break;
        case "timeCreated":
          if (!this.sorts2) {
            this.sorts2 = "timeCreated ASC";
          } else {
            if (this.sorts2 == "timeCreated DESC") {
              this.sorts2 = "timeCreated ASC";
            } else {
              this.sorts2 = "timeCreated DESC";
            }
          }
          break;
      }
      this.$emit("sortList", type, this.sorts2);
    },
    mgrImg(item, sku, max) {
      this.$emit("mgrImg", item, sku, max);
    },
    sortItemNew(sortType, i) {
      if (!this.items[i].sorts) {
        this.items[i].sorts = "ASC";
      } else {
        if (this.items[i].sorts == "DESC") {
          this.items[i].sorts = "ASC";
        } else {
          this.items[i].sorts = "DESC";
        }
      }
      this.sortI = i;
      this.$emit("sortItemNew", sortType, this.sortI, this.items[i].sorts);
    },
    fileClick(i) {
      document.getElementById(`upload_file_btn${i}`).click();
    },
    imgBase64(event, item, obj) {
      let el = event.target;
      if (el.value) {
        //$t('product.转')base64
        base64Image({
          width: 9999999999,
          file: el,
          callback: (rst) => {
            this.$emit("uploadSkuImg", rst, item, obj);
          },
        });
      }
    },
    getHtml(item) {
      if (!item) return;
      let arr = item.split("|");
      let html = "";
      html = `<span>${arr[0]}<br/>${arr[1]}</span>`;
      return html;
    },
    popContact(event, i, id) {
      this.$emit("popContact", event, i, id);
    },
    uploadProSpuImg(item) {
      this.$emit("uploadProSpuImg", item);
    },
    uploadProSkuImg(item, obj) {
      this.$emit("uploadProSkuImg", item, obj);
    },
    changeAllCheck(e) {
      this.checkArr = [];
      if (e.target.checked) {
        this.items.forEach((e) => {
          this.checkArr.push(e.sku);
        });
      }
    },
    isEmpty(obj) {
      if (
        typeof obj == "undefined" ||
        obj == null ||
        obj == "" ||
        obj == "null"
      ) {
        return true;
      } else {
        return false;
      }
    },
    imgUrlFormat(value) {
      if (!this.isEmpty(value)) {
        return JSON.parse(value);
      }
    },
    channelType(item) {
      if(this.userinfo.productStyle == 2){
        this.$emit("channelTypeW", item)
      } else {
        this.$emit("channelType", item);
      }
      
    },
    remarkFormat(r) {
      //$t('product.备注格式化成')html
      if (!r || !r.length || !Array.isArray(r)) return;
      let html = "";
      r.forEach((e) => {
        html += `<p class="mg-b-5">${e}</p>`;
      });
      return html;
    },
    innerTableStatus(i) {
      this.$set(this.openInner, i, !this.openInner[i]);
    },
    accordionProducts() {
      this.$emit("accordionProducts");
    },
    openInnerFormat() {
      this.openInner = [];
      for (let i = 0; i < this.items.length; i++) {
        this.openInner.push(false);
        if (!this.isAccordion) {
          this.openInner[i] = !this.isAccordion;
        }
        //      if (
        //        this.items[i] && this.items[i].stocks && this.items[i].stocks.length > 0
        //      ) {
        //      	console.log(!this.isAccordion)
        //        this.openInner[i] = !this.isAccordion;
        //      }
      }
    },
    modalGoto(index) {
      this.modalHotProduct.page = index;
      this.modalHotProduct.loading = false;
      $("#modalHotProduct .modal-body").scrollTop(0);
      this.getRecords();
    },
    showCntMore(id) {
      this.modalHotProduct = JSON.parse(this.modalHotProductDefault);
      this.modalHotProduct.id = id;
      this.getRecords();
      $("#modalHotProduct").modal("show");
    },
    getRecords() {
      this.modalHotProduct.loading = true;
      $.api_call(
        "api.SupplierProduct.findHotProductRecords",
        {
          page: this.modalHotProduct.page,
          rowsPerPage: this.modalHotProduct.rowsPerPage,
          hotProductId: this.modalHotProduct.id,
        },
        (r) => {
          this.modalHotProduct.loading = false;
          if (r.ErrorCode == "9999") {
            this.modalHotProduct.items = r.Data.Results;
            this.modalHotProduct.totalPage = r.Data.Pagination.totalPage;
          } else {
            $("#modalHotProduct").modal("hide");
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    preview(img, text) {
      if (!img) return;
      this.$parent.loading = true;
      let imgArr = [];
      imgArr.push({
        img: img,
        text,
      });
      this.$store.commit("setImgItem", imgArr);
      setTimeout(() => {
        const viewer = document.querySelector(".app-images-arr").$viewer;
        viewer.index = 0;
        viewer.show();
        this.$parent.loading = false;
      }, 500);
    },
    previewMore(img, text) {
      if (!img) return;
      this.$parent.loading = true;
      let imgArr = [];
      JSON.parse(img).forEach((e) => {
        imgArr.push({
          img: e,
          text,
        });
      });
      this.$store.commit("setImgItem", imgArr);
      setTimeout(() => {
        const viewer = document.querySelector(".app-images-arr").$viewer;
        viewer.index = 0;
        viewer.show();
        this.$parent.loading = false;
      }, 500);
    },
    //  sortItem(sortType) {
    //    if (sortType == this.sortType) {
    //      //$t('product.恢复默认')
    //      sortType = 1;
    //    }
    //    this.$emit("sortItem", sortType);
    //  },
    editNewProduct(item) {
      this.$emit("editNewProduct", item);
    },
    delNewProduct(item) {
      this.$emit("delNewProduct", item);
    },
  },
};
</script>


<style lang="less" scoped>
th {
  a:hover {
    color: #adb5bd;
  }
  a.hover-info:hover {
    color: #17a2b8;
  }
}
.pro {
  display: flex;
  max-width: 450px;
  .img-wrap {
    border: 1px #ddd solid;
    width: 90px;
    height: 90px;
    min-width: 90px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    margin-right: 10px;
  }
  .link {
    .title {
      width: 85px;
    }
  }
}
.sub-li .img-wrap {
  min-width: 70px;
  width: 70px;
  height: 70px;
}
.sub-li .mgr-img-wrap {
  width: 70px;
  height: 70px;
  min-width: 70px;
}
.sub-li .mgr-img-wrap .p-img-wrap.mult {
  width: 65px;
  height: 65px;
  min-width: 65px;
}
.sub-li .mgr-img-wrap .mult-img-bg {
  width: 65px;
  height: 65px;
}
.sub-li {
  margin-bottom: 5px;
  .bg1 {
    background-color: #f5f5f5;
  }
}
.bg-sub {
  background-color: rgba(0, 0, 0, 0.4);
}
.bg-sub.bg-sub2 {
  background-color: rgba(0, 0, 0, 0.2);
}
.product-table .p-info {
  width: auto;
}
.white-body {
  .bg-sub {
    background-color: #e6e6e6;
  }
  .bg-sub.bg-sub2 {
    background-color: #f6f6f6;
  }
}
table td {
  word-break: keep-all;
  white-space: nowrap;
  padding: 6px 10px;
}
table th {
  word-break: keep-all;
  white-space: nowrap;
  padding: 6px 10px;
  color: #868ba1 !important;
  font-weight: normal;
}
.overflow {
  overflow-x: scroll !important;
}
.pro .ckbox {
  width: 18px;
}
.pos-relative {
  width: 120px;
  height: 120px;
  min-width: 120px;
}
.pos-relative .num {
  position: absolute;
  top: 0;
  right: 5px;
  z-index: 2;
  background-color: #1caf9a;
  color: #fff;
  padding: 0 3px;
  height: 18px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 18px;
}
.pos-relative .p-img-wrap {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  margin-right: 0;
  background-color: #fff;
  /*-webkit-transform: scale(.9);
    transform: scale(.9);*/
  border: 1px solid #161f2b;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
  width: 120px;
  height: 120px;
}
.pos-relative .mult-img-bg {
  position: absolute;
  top: 5px;
  left: 5px;
  width: 120px;
  height: 120px;
  /*-webkit-transform: scale(.9);
    transform: scale(.9);*/
  background: #666;
  border: 1px solid #333;
}
.white-body .pos-relative .mult-img-bg {
  background: #e6e6e6;
}
.img-mgr {
  bottom: 5px;
  z-index: 1;
  left: 50%;
  transform: translateX(-50%);
}
th a.sp-dd.tx-info:hover {
  color: #148ea1 !important;
}
.fixed-page .br-pagebody .body-wrap {
  overflow-y: scroll;
}
.sp-dd::before {
  z-index: 1 !important;
}
.hidden-btn {
  display: none;
  height: 80px;
  width: 33px;
  background: rgb(233, 236, 239);
  left: -30px;
  top: 20px;
  position: absolute;
  z-index: 9;
}
.hidden-btn2 {
  display: none;
  right: -30px;
  height: 80px;
  width: 33px;
  background: rgb(233, 236, 239);
  top: 20px;
  position: absolute;
  z-index: 0;
}
</style>
